import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
  },
}));

export default useStyles;
